import { NBSP } from 'shared/constants/text';
import { OFFER_CONDITION_LABELS, OFFER_PROPERTY_TITLES } from 'shared/constants/buildingLabels';
import { formatArea, formatDecimal, formatRubles, noBreak } from 'shared/utils/format';
import type { ICategoryOffer, TOffersDealType } from 'shared/types/buildingOffers';

import { getRentRatePerYear, getSalePricePerMeter } from './formatOfferValues';
import { getCategoryPropertyType } from './offersFilters';

export interface IOfferPreviewProp {
  name: string;
  value: string;
  /** «Площадь» — жирным и название, и значение */
  isImportant?: boolean;
}

export interface IOfferPreviewView {
  title: string;
  /** «свободен» / «занята» и т.п.; null — занятость неизвестна */
  occupancy: { text: string; isOccupied: boolean } | null;
  price: string | null;
  pricePerMeter: string | null;
  props: IOfferPreviewProp[];
}

/** Данные превью объявления (`offer_preview.tsx` монолита) */
export function getOfferPreview(offer: ICategoryOffer, dealType: TOffersDealType): IOfferPreviewView {
  const propertyType = getCategoryPropertyType(offer.category);
  const titles = propertyType ? OFFER_PROPERTY_TITLES[propertyType] : null;
  const perMeter = dealType === 'rent' ? getRentRatePerYear(offer) : getSalePricePerMeter(offer);
  const condition = offer.conditionType ? OFFER_CONDITION_LABELS[offer.conditionType] : undefined;

  const props: IOfferPreviewProp[] = [
    { name: 'Площадь', value: offer.totalArea === null ? '' : formatArea(offer.totalArea), isImportant: true },
    {
      name: 'Потолки',
      value: offer.ceilingHeight ? `${noBreak(formatDecimal(offer.ceilingHeight))}${NBSP}м` : '',
    },
    { name: 'Состояние', value: condition ?? '' },
    { name: 'Мебель', value: offer.hasFurniture === null ? '' : offer.hasFurniture ? 'есть' : 'нет' },
  ];

  return {
    title: titles?.title ?? '',
    occupancy:
      titles && offer.isOccupied !== null
        ? { text: offer.isOccupied ? titles.occupied : titles.free, isOccupied: offer.isOccupied }
        : null,
    price: offer.price === null ? null : formatRubles(offer.price),
    pricePerMeter:
      perMeter === null ? null : `${formatRubles(perMeter)} за${NBSP}м²${dealType === 'rent' ? ' в год' : ''}`,
    props: props.filter(({ value }) => value),
  };
}
